export enum FilterType {
  Equals,
  NotEquals,
  Includes,
  StartsWith,
  GreaterThan,
  GreaterThanOrEquals,
  LessThan,
  LessThanOrEquals
}
